import { Vue, Component, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import TreeChart from '@/components/charts/tree-chart/tree-chart';
import { getCategoryId, getSubjectId, getCourseId, getDomainId } from '@/utils/taxonomy';
import PullOutTree from '@/components/cards/tree-pull-out/tree-pull-out';
import {
  DEPTH_FILTER,
  COMPETENCY_TREE_GROUP,
  DEMO_USER_ACCESS_CATEGORIES_LIST,
  CAP_CATEGORIES, CAP_SUBJECTS,
  DEFAULT_SUBJECT_SORTING,
  TREE_LIST_SECTION,
  GROUP_SORTING,
} from '@/utils/constants';
import { searchAPI } from '@/providers/apis/search/search';
import { sortByArray, sortByProperty } from '@/utils/utils';
import { taxonomySerializer } from '@/providers/serializers/taxonomy/taxonomy';
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { sessionService } from '@/providers/services/auth/session';
import { competencyAPI } from '@/providers/apis/competency/competency';
import moment from 'moment';
import axios from 'axios';
import { Domain } from '@/models/proficiency/domain-topic/domain';
import { Topic } from '@/models/proficiency/domain-topic/topic';
import Competency from '../competency';

@Component({
  name: 'tree',
  components: {
    'material-icon': GoogleMaterialIcon,
    'tree-chart': TreeChart,
    'pull-out': PullOutTree,
    'scale-loader': ScaleLoader,
  },
})

export default class Tree extends Vue {

  // ---------------------------------------------------------------
  // Properties

  private get classification() {
    return this.$store.state.activityStore.categoryList;
  }

  private isShowPullout: boolean = false;

  private filterParams: any = {};

  private taxonomyTreeViewData: any = {
    name: 'Gooru',
    type: 'root',
    id: 'GDT',
    children: [],
  };

  private categories: any = [];

  private loading: boolean = false;

  private isZoom: boolean = false;

  private isLoading: boolean = false;

  private subjectList: any = [];

  private groupList: any = [];

  private get treeHeads() {
    const treeSections: any = [];
    const items = (sectionName: any, index: number) => {
      treeSections.push({ name: sectionName, id: `section-${index + 1}` });
    };
    TREE_LIST_SECTION.forEach(items);
    return treeSections;
  }

  private get isSuperUser() {
    const session = sessionService.getSession();
    return this.$access.isDemoTenant;
  }


  public renderDomainCodesData(node: any) {
    const component = this;
    const competencies = node.data.childData;
    const promise = competencies.map((competency: any) => {
      const subjectId = getSubjectId(competency.id);
      const courseId = getCourseId(competency.id);
      const domainId = getDomainId(competency.id);
      const subject = this.subjectList.find((item: any) => item.id === subjectId);
      const frameworkId = subject ? subject.frameworkId : null;
      return taxonomyAPI.
        fetchTaxonomyCodes(frameworkId, subjectId, courseId, domainId)
        .then((codes) => {
          const standards = taxonomySerializer.createStandardsHierarchy(codes);
          node.data.childData = standards;
          // Set reference to parent
          standards.forEach((standard: any) => {
            standard.parent = node.data;
          });
          return standards;
        });
    });
    return Promise.all(promise).then(() => {
      const topicNode = node.data;
      component.renderStandardCodes(topicNode.childData, topicNode, competencies);
    });
  }
  // ------------------------------------------------------------------------
  // Hooks
  private created() {
    this.fetchCategories();
  }


  // --------------------------------------------------------------------------
  // Actions
  /**
   * Action triggered  when node get clicked from tree node.
   * @param  {Object} d selected node
   * @param  {Object} component
   */
  private onClickTaxonomyNode(node: any, component: any) {
    const controller = this;
    const taxonomyTreeViewData = this.taxonomyTreeViewData;
    const id = node.data.id;
    this.scrollHeader(node);
    // let isNodeLoading = component.get('isNodeLoading');
    const isNodeLoading = false;
    if (!isNodeLoading) {
      // if (node.depth === 1) {
      //   const categoryNodes = taxonomyTreeViewData.children;
      //   const category = categoryNodes.find((item: any) => item.id === id);
      //   const groupdNodes = category.children;
      //   const categories = this.categories;
      //   const activeCategory = categories.find((item: any) => item.id === id);
      //   groupdNodes.forEach((groupItem: any) => {
      //     const activeGroup = activeCategory.groups.find((item: any) => item.id === groupItem.id);
      //     this.parseTaxonomyData(activeGroup.subjects, groupItem, false);
      //   });
      //   component.updateData(node, groupdNodes);
      // } else
      if (node.depth === 1) {
        const subjectNodes = node.data.children;
        const subject = subjectNodes ? subjectNodes[0] : {};
        const courseNodes = subject.childData;
        if (!courseNodes) {
          controller.renderCoursesData(node).then(() => {
            component.updateData(node, subjectNodes);
          });
        } else {
          component.updateData(node, subjectNodes);
        }
      } else if (node.depth === 2) {
        const categoryNodes = taxonomyTreeViewData.children;
        const category = categoryNodes.find((item: any) => {
          return item.code === controller.getCategoryIdByIfGroupApplicable(id);
        });
        controller.getCategoryIdByIfGroupApplicable(id);
        // const groupNodes = category.children;
        // const activeGroup = groupNodes.find((item: any) => item.id === node.data.parent);
        const subjectNodes = category.children;
        const subject = subjectNodes.find((item: any) => item.id === id);
        const courseNodes = subject.childData;
        const course = courseNodes[0];
        const domainNodes = course.childData;
        if (!domainNodes) {
          controller.renderCourseDomainsData(node).then(() => {
            component.updateData(node, courseNodes);
          });
        } else {
          component.updateData(node, courseNodes);
        }
      } else if (node.depth === 3) {
        const domain = node.data;
        const topoicNodes = domain.childData;
        component.updateData(node, topoicNodes);
      } else if (node.depth === 4) {
        controller.renderDomainCodesData(node).then(() => {
          let standardNodes = node.data.childData;
          standardNodes = standardNodes.filter((item: any) => item.name !== undefined);
          component.updateData(node, standardNodes);
        });

      } else if (node.depth === 5) {
        const microStandardNodes = node.data.childData;
        component.updateData(node, microStandardNodes);
      }
    }
  }

  private onClickNodeMoreInfo(d: any, datas: any) {
    const params: any = {};
    this.isLoading = true;
    this.isShowPullout = true;
    const list = (item: any, callback: any) => {
      if (item.depth !== 2) {
        params[DEPTH_FILTER[item.depth]] = item.data.id;

      }

      if (item.depth > 1) {
        callback(item.parent, list);
      }
    };
    list(d, list);
    if (d.depth < 7) {
      this.fetchPulloutContet(d, params);
    } else {
      this.pulloutContentByLearningmap(d, params);
    }

  }


  // --------------------------------------------------------------------------
  // Methods
  private loadCategoryList(categories: any) {
    const categoriesList: any = [];
    const promise = categories.map((category: any) => {
      return new Promise((resolve, reject) => {
        return taxonomyAPI.fetchTaxonomySubjects(category.id).then((subjects) => {
          sortByProperty(subjects, 'sequenceId', 'ASC');
          // Demo purpose for cap library
          if (this.$access.isCapLibrary) {
            subjects.map((sub: any) => {
              sub.isDisabled = true;
              if (CAP_SUBJECTS.indexOf(sub.id) !== -1) {
                sub.isDisabled = false;
              }
              return sub;
            });
            subjects = subjects.sort((a: any, b: any) => {
              return CAP_SUBJECTS.indexOf(a.id) - CAP_SUBJECTS.indexOf(b.id);
            });
            sortByProperty(subjects, 'isDisabled', 'ASC');
          }
          this.subjectList = this.subjectList.concat(subjects);
          categoriesList.push({
            title: category.title,
            type: 'category',
            id: category.id,
            code: category.code,
            subjects,
            groups: this.parseSubjectGroups(subjects, category.id),
          });
          return resolve(categoriesList);
        });
      });
    });
    return Promise.all(promise).then(() => {
      return categoriesList;
    });
  }

  private parseTaxonomyData(data: any, targetData: any, pushDataToChild: any) {
    const childData: any = [];
    data.forEach((item: any) => {
      childData.push(this.createNode(item));
    });
    if (pushDataToChild) {
      targetData.children = childData;
    } else {
      targetData.childData = childData;
    }
    if (childData.length > 0) {
      targetData.hasChild = true;
    } else {
      targetData.hasChild = false;
    }
  }

  private createNode(data: any, isShowDisplayCode = false) {
    const node = {
      id: data.id,
      code: data.code,
      name: isShowDisplayCode ? data.code : data.title,
      title: data.title,
      default: data.is_default ? data.is_default : false,
      isDisabled: data.isDisabled || false,
      children: null,
    };
    return node;
  }

  private renderCoursesData(node: any) {
    const compontent = this;
    const categoryId = node.data.id;
    // const categoryId = node.parent.data.id;
    const categories = this.categories;
    const category = categories.find((item: any) => item.id === categoryId);
    // const activeGroup = category.groups.find((item: any) => item.id === id);
    const subjects = category.subjects;
    const promises = subjects.map((subject: any) => {
      const params = {
        subject: subject.id,
        month: moment().format('MM'),
        year: moment().format('YYYY'),
        user: sessionService.getSession()!.user_id,
      };
      return axios.all([
        competencyAPI.fetchDomainTopicCompetencyMatrix(params),
        competencyAPI.fetchSubjectDomainTopicMetadata({ subject: subject.id }),
      ]).then(axios.spread((matrix, topics) => {
        const doaminsList: Domain[] = compontent.parseDomainMatrixTopics(matrix, topics);
        subject.domains = doaminsList;
      }));
    });
    return Promise.all(promises).then(() => {
      const categoryNodes = compontent.taxonomyTreeViewData.children;
      const categoryNode = categoryNodes.find((item: any) => item.id === categoryId);
      // const groupNode = categoryNode.children.find((item: any) => item.id === id);
      const childNodes = categoryNode.children;
      subjects.forEach((subject: any) => {
        const targetNode = childNodes.find((item: any) => item.id === subject.code);
        compontent.parseTaxonomyData(subject.domains, targetNode, false);
      });
    });
  }

  private renderCourseDomainsData(node: any) {
    const id = node.data.id;
    const controller = this;
    const categories = this.categories;
    const categoryId = controller.getCategoryIdByIfGroupApplicable(id);
    const category = categories.find((item: any) => item.code === categoryId);
    // const activeGroup = category.groups.find((item: any) => item.id === node.data.parent);
    const subjects = category.subjects;
    const subject = subjects.find((item: any) => item.id === id);
    const domains = subject.domains;
    const promises = domains.map((domain: Domain | any) => {
      const promiseData = domain.topics.map((topic: any) => {
        topic.level = 2;
        topic.parent = domain.id;
        return topic;
      });
      return Promise.all(promiseData).then(() => {
        domain.children = domain.topics;
        domain.childData = domain.topics;
        return domains;
      });
    });

    return Promise.all(promises).then(() => {
      const categoryNodes = controller.taxonomyTreeViewData.children;
      const categoryNode = categoryNodes.find((item: any) => item.code === categoryId);
      // const groupNode = categoryNode.children.find((item: any) => item.id === node.data.parent);
      const subjectNodes = categoryNode.children;
      const subjectNode = subjectNodes.find((item: any) => item.id === id);
      const childNodes = subjectNode.childData;
      domains.forEach((domain: any) => {
        const targetNode = childNodes.find((item: any) => item.code === domain.code);
        controller.parseTaxonomyData(domain.children, targetNode, false);
        domain.topics.forEach((topic: any) => {
          const targetTopic = targetNode.childData.find((item: any) => item.code === topic.code);
          topic.children = topic.competencies;
          topic.childData = topic.competencies;
          controller.parseTaxonomyData(topic.children, targetTopic, false);
        });
      });
    });
  }
  private fetchCategories() {
    this.$store.dispatch('activityStore/fetchCategory').then(async () => {
      this.loadCategoryList(this.classification).then(async (categories) => {
        if (categories.length) {
          if (this.isSuperUser) {
            categories = await this.parseDemoCategoryList(categories);
          }
          const promiseCategory = categories.map((category: any) => {
            category = Object.assign(category, COMPETENCY_TREE_GROUP[category.id]);
            if (!this.$access.isCapLibrary && category.subjects) {
              category.subjects = this.sequenceSubjectsList(category.subjects);
            }
            return category;
          });
          Promise.all(promiseCategory).then(() => {
            // Demo purpose for cap library
            sortByProperty(categories, 'sequence', 'ASC');
            if (this.$access.isCapLibrary) {
              categories = categories.map((cat: any) => {
                cat.isDisabled = true;
                if (CAP_CATEGORIES.indexOf(cat.id as any) !== -1) {
                  cat.isDisabled = false;
                }
                return cat;
              });
              sortByProperty(categories, 'isDisabled', 'ASC');
            }
            this.categories = categories;
          });
        }

      });
    });
  }

  @Watch('categories')
  private awsonChangeCategory(value: any) {
    this.parseTaxonomyData(this.categories, this.taxonomyTreeViewData, true);
    const categoryNode = this.taxonomyTreeViewData.children;
    const promise = value.map((category: any) => {
      const targetCategoryNode = categoryNode.find((item: any) => item.id === category.id);
      const subjects = category.subjects;
      this.parseTaxonomyData(subjects, targetCategoryNode, true);
    });
  }


  private renderStandardCodes(datas: any, targetNode: any, competencies: any) {
    const controller = this;
    const standards: any = [];
    datas.forEach((data: any) => {
      const standardLevel1s = data.children;
      standardLevel1s.forEach((standardLevel1: any) => {
        if (standardLevel1.children && standardLevel1.children.length > 1) {
          const standardsCopy = {
            children: [],
            code: standardLevel1.code,
            codeType: standardLevel1.codeType,
            id: standardLevel1.id,
            level: standardLevel1.level,
            parent: standardLevel1.parent,
            title: standardLevel1.title,
          };
          standards.push(standardsCopy);
          const standardLevel2s = standardLevel1.children;
          standardLevel2s.forEach((standardLevel2: any) => {
            standards.push(standardLevel2);
          });
        } else {
          standards.push(standardLevel1);
        }
      });
    });
    const children: any = [];
    if (standards && standards.length > 0) {
      standards.forEach((standard: any) => {
        const standardNode = controller.createNode(standard, false);
        const standardChildNodes = standard.children;
        if (standardChildNodes && standardChildNodes.length > 0) {
          const standardChildNode: any = [];
          standardChildNodes.forEach((standardChild: any) => {
            const microStandardNodes = standardChild.children;
            if (microStandardNodes && microStandardNodes.length > 0) {
              microStandardNodes.forEach((microStandard: any) => {
                standardChildNode.push(
                  controller.createNode(microStandard, false),
                );
              });
            } else {
              standardChildNode.push(
                controller.createNode(standardChild, false),
              );
            }
          });
          this.$set(standardNode, 'childData', standardChildNode);
          if (standardChildNode.length > 0) {
            this.$set(standardNode, 'hasChild', true);
          } else {
            this.$set(standardNode, 'hasChild', false);
          }
        }
        if (competencies.find((item: any) => item.id === standardNode.id)) {
          children.push(standardNode);
        }

      });

      this.$set(targetNode, 'childData', children);
      if (children.length > 0) {
        this.$set(targetNode, 'hasChild', true);
      } else {
        this.$set(targetNode, 'hasChild', false);
      }
    }
  }
  private fetchPulloutContet(d: any, params: any) {
    this.$store.dispatch('activityStore/fetachLearnerContent', { params }).then(() => {
      this.isLoading = false;
      this.filterParams = {
        selectedItems: d,
        content: this.$store.state.activityStore.learnerContent.params,
      };
      this.chartUpdated();
    });
  }

  private pulloutContentByLearningmap(d: any, params: any) {
    searchAPI.fetchLearningMapContents(params.competencyCode).then((content) => {
      this.isLoading = false;
      this.filterParams = {
        selectedItems: d,
        content,
      };
      this.chartUpdated();
    });
  }

  private async parseDemoCategoryList(categories: any) {
    const demoList = DEMO_USER_ACCESS_CATEGORIES_LIST;
    demoList.forEach((group) => {
      let subjects: any = [];
      group.included.forEach((category) => {
        const availableCategory = categories.find((item: any) => item.id === category);
        if (availableCategory) {
          availableCategory.groups.forEach((groupSubject: any) => {
            subjects = [...subjects, ...groupSubject.subjects];
          });
        }
        if (group.subjectIds) {
          subjects = subjects.filter((subject: any) => group.subjectIds.indexOf(subject.id) !== -1);
          subjects = subjects.sort((a: any, b: any) => {
            return group.subjectIds.indexOf(a.id) - group.subjectIds.indexOf(b.id);
          });
        }
      });
      const groups = this.parseSubjectGroups(subjects, group.id);
      this.$set(group, 'subjects', subjects);
      this.$set(group, 'groups', groups);
    });
    return demoList.filter((item: any) => item.subjects.length);
  }

  private getCategoryIdByIfGroupApplicable(id: string) {
    const demoList = DEMO_USER_ACCESS_CATEGORIES_LIST;
    const category = demoList.find((group) => group.included.indexOf(getCategoryId(id)) > -1);
    if (this.isSuperUser) {
      return category ? category.code : getCategoryId(id);
    }
    return getCategoryId(id);
  }

  private parseDomainMatrixTopics(competencyMatrix: Domain[], domainsMatrix: Domain[]) {
    domainsMatrix.forEach((domain: Domain | any) => {
      domain.code = domain.domainCode;
      domain.title = domain.domainName;
      domain.id = domain.domainCode;
      const activeDomain: Domain | any = competencyMatrix.find(
        (domainMatrix) => domainMatrix.domainCode === domain.domainCode);
      domain.topics.forEach((topic: Topic | any) => {
        topic.code = topic.topicCode;
        topic.title = topic.topicName;
        topic.id = topic.topicCode;
        const topicMatrix: Topic = activeDomain.topics.find(
          (matrixTopic: Topic) => matrixTopic.topicCode === topic.topicCode);
        topic.competencies = topicMatrix ? topicMatrix.competencies : [];
        topic.competencies.forEach((competency: any) => {
          competency.title = competency.competencyName;
          competency.code = competency.competencyCode;
          competency.id = competency.competencyCode;
          competency.parent = topic.topicCode;
        });
      });
    });
    return domainsMatrix;
  }

  private sequenceSubjectsList(subjects: any) {
    const defaultSub = DEFAULT_SUBJECT_SORTING;
    const nonDefaultSub = subjects.filter((item: any) => defaultSub.indexOf(item.id) === -1);
    let activeIndex = 0;
    for (const subId of defaultSub) {
      const activeSub = subjects.find((item: any) => item.id === subId);
      if (activeSub) {
        nonDefaultSub.splice(activeIndex, 0, activeSub);
        activeIndex++;
      }
    }
    return nonDefaultSub;
  }

  private scrollHeader(node: any) {
    const scrollEl = this.$el.querySelector('.tree-chart');
    scrollEl!.addEventListener('scroll', this.moveElPosition);
  }

  private moveElPosition() {
    const nodeEl = this.$el.querySelector('.tree-chart .node-1')!.getBoundingClientRect();
    const domainHead = this.$el.querySelector('.tree-domain-name') as HTMLElement;
    domainHead.style!.left = `${nodeEl!.left - 50}px`;
    const nodeList = new Array(6).fill({});
    let preMinValue = 0;
    nodeList.forEach((item, index) => {
      const activeIndex = index + 1;
      const currentNode = this.$el.querySelector(`.node-${activeIndex}`);
      const nextNode = this.$el.querySelector(`.node-${activeIndex + 1}`);
      const nextPosition = nextNode ? nextNode!.getBoundingClientRect() : null;
      const currentPosition = currentNode ? currentNode!.getBoundingClientRect() : null;
      if (currentPosition) {
        let width = currentPosition.width;
        if (nextPosition) {
          const minValue = nextPosition.left - (currentPosition.left + width);
          width = width + (minValue / 2) + (preMinValue / 2);
          preMinValue = minValue;
        } else {
          width = width + (preMinValue / 2);
        }
        if (activeIndex === 1 || !nextNode || (activeIndex === nodeList.length)) {
          width += 50;
        }
        const activeEl = (this.$el.querySelector(`.section-${activeIndex}`) as HTMLElement);
        activeEl.style.width = `${width}px`;
      }

    });
  }

  private chartUpdated() {
    setTimeout(() => {
      this.moveElPosition();
    }, 50);
  }


  private parseSubjectGroups(subjects: any, id: string) {
    subjects.forEach((subject: any) => {
      if (subject.groupCodeLabel === null || subject.groupCodeLabel === '') {
        this.$set(subject, 'groupCodeLabel', 'Common');
      }
    });
    const excludeFilter = ['Common', 'Others'];
    let groupCodes = [...new Set(subjects.map((item: any) => item.groupCodeLabel))].filter((item) => item);
    const groupWithoutCommon = groupCodes.filter((item: any) => excludeFilter.indexOf(item) === -1);
    const groupWithCommon = groupCodes.filter((item: any) => excludeFilter.indexOf(item) !== -1);
    groupCodes = groupWithoutCommon.concat(groupWithCommon);
    sortByArray(groupCodes, GROUP_SORTING);
    const groupList: any = [];
    groupCodes.forEach((groupCode: any) => {
      const groupLevel = {
        id: groupCode,
        code: groupCode,
        title: groupCode,
        categoryId: id,
        subjects: this.createGroupNode(subjects, groupCode),
      };
      groupList.push(groupLevel);
    });
    return groupList;
  }

  private createGroupNode(subjects: any, groupCode: string) {
    return subjects.filter((item: any) => (item.groupCodeLabel === groupCode
      || (groupCode === 'Common' && !item.groupCodeLabel)));
  }
}
